import { useTheme } from "@mui/material/styles";
import { ExpandMoreRounded } from "@mui/icons-material";
import { useStyle } from "./style";

interface IParams {
    className: string;
}

export const SelectIcon = (props: IParams) => {
    const theme = useTheme();
    const { classes } = useStyle();
    const { className } = props;

    return (
        <ExpandMoreRounded
            className={className + " " + classes.icon}
            fontSize="large"
            style={{ fill: theme.palette.primary.main }}
        />
    );
};
